// extracted by mini-css-extract-plugin
var _1 = "RIH65ywWlObQn8L3sM3z";
var _2 = "tYG7m7BBWQuf6bJDamWy";
export { _1 as "amountBox", _2 as "title" }
